/**
 * Helpers for creating Auth instance
 */

import type { IBaseApiService } from "../../../BaseApiServiceFactory";
import type { IAuth } from "../Auth";
import {
	createMailVerifySmsMethod,
	createVerifyTotpCodeMethod,
	createSetPasswordMethod,
	createLoginMethod,
	createAskNewPasswordMethod,
	createSendAnotherCodeMethod,
	createLogoutMethod,
} from "./authMethodsHelpers";

export type AuthInstance = IAuth;

/**
 * Create Auth instance with all methods
 */
export function createAuthInstance(baseApi: IBaseApiService): AuthInstance {
	const namespaceUrl = baseApi.getBaseUrl().concat("/customer");
	const baseUrl = namespaceUrl.concat("/auth");

	return {
		mailVerifySms: createMailVerifySmsMethod(baseApi, baseUrl),
		verifyTotpCode: createVerifyTotpCodeMethod(baseApi, baseUrl),
		setPassword: createSetPasswordMethod(baseApi, baseUrl),
		login: createLoginMethod(baseApi, baseUrl),
		askNewPassword: createAskNewPasswordMethod(baseApi, baseUrl),
		sendAnotherCode: createSendAnotherCodeMethod(baseApi, baseUrl),
		logout: createLogoutMethod(baseApi),
	};
}
